import { Component, computed, inject, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { ICampaignForm } from '@campaign-form/campaign-form.interface';
import { ECurrency } from '@enums/campaign.enum';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BudgetComponent } from '@shared/components/budget/budget.component';
import { MatErrorComponent } from '@shared/components/mat-error/mat-error.component';

@Component({
  imports: [
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    ReactiveFormsModule,
    TranslateModule,
    BudgetComponent,
    MatErrorComponent,
  ],
  selector: 'app-campaign-finance',
  templateUrl: './campaign-finance.component.html',
})
export class CampaignFinanceComponent {
  public readonly form = input.required<FormGroup<ICampaignForm>>();

  public readonly currencies = computed(() =>
    Object.entries(ECurrency).map(([, value]) => ({
      label: this.getCurrencyLabel(value),
      value,
    })),
  );

  private readonly translate = inject(TranslateService);

  private getCurrencyLabel(currency: ECurrency): string {
    switch (currency) {
      case ECurrency.usd:
        return this.translate.instant('pages.campaignForm.sections.currency.usd');
      case ECurrency.eur:
        return this.translate.instant('pages.campaignForm.sections.currency.eur');
    }
  }
}
